import { render } from "./CurrencyDropdown.vue?vue&type=template&id=8f9acd72&scoped=true&ts=true"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=ts"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=ts"

import "./CurrencyDropdown.vue?vue&type=style&index=0&id=8f9acd72&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9acd72"]])

export default __exports__